import React, { MouseEvent, MouseEventHandler, ReactElement } from "react";
import { Modal as ModalBase, ModalProps, Space } from "antd";
import CustomBtn from "@funds/pages/MyFunds/pages/StakingPage/parts/shared/CustomBtn/CustomBtn";

import * as style from "./ModalStyle.module.scss"

type Props = ModalProps & {
  children: ReactElement;
  onCancel: (value: React.SetStateAction<boolean>) => void;
  disabled?: boolean;
  onConfirm: MouseEventHandler<HTMLElement>;
  isLoading?: boolean;
};

const Modal = ({
  children,
  onCancel,
  disabled = false,
  onConfirm,
  isLoading = false,
  ...rest
}: Props) => {
  const footer = (
    <Space direction="vertical" style={{ width: "100%" }}>
      <CustomBtn
        myType="submit"
        onClick={onConfirm}
        loading={isLoading}
        style={{
          padding: "25px 15px",
          lineHeight: "0px",
        }}
        disabled={disabled}
      >
        Yes, I confirm
      </CustomBtn>

      <CustomBtn
        myType="cancel"
        style={{ border: 0, boxShadow: "none" }}
        onClick={onCancel}
      >
        Cancel
      </CustomBtn>
    </Space>
  );

  return (
    <ModalBase
      centered
      footer={footer}
      onCancel={onCancel}
      closable
      className={style.modal}
      {...rest}
    >
      {children}
    </ModalBase>
  );
};

export default Modal;
